// removed by extract-text-webpack-plugin
module.exports = {"dialog-min":"_3qc-ffRov0IzXnYyM66Nsa"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/organisms/dialog-min.scss
// module id = 13279
// module chunks = 0